import React from 'react';
import ReactDOM from 'react-dom';

import SettingsContext from '../context/SettingsContext';
import SettingsPage from '../components/SettingsPage';

export default class SettingsController {
	init(state, mount_root_id) {
		const context = new SettingsContext(state);

		ReactDOM.render(
			<SettingsPage context={context} />,
			document.getElementById(mount_root_id)
		);
	}
}